<template>
  <app-content class="h-panel" style="overflow: hidden">
    <div style="margin: 20px 20px 0px 20px">
      <DropdownCustom ref="paramsDropdown" button class="h-btn-primary" trigger="click">
        <div v-if="params.voucherDate.start!==params.voucherDate.end">{{ fqFormat(params.voucherDate.start) }} 至 {{ fqFormat(params.voucherDate.end) }}</div>
        <div v-else>{{ fqFormat(params.voucherDate.start) }}</div>
        <template #content>
          <Form style="padding: 10px;width: 400px">
            <FormItem class="!pb-5px" label="会计期间">
              <div class="flex items-center">
                <Select @change="dateCheck" v-model="params.voucherDate.start" :deletable="false" filterable :datas="checkoutSelect"/>
                <span class="mx-8px">至</span>
                <Select @change="dateCheck" v-model="params.voucherDate.end" :deletable="false" filterable :datas="checkoutSelect"/>
              </div>
            </FormItem>
            <FormItem class="!pb-5px" label="排序方式">
              <Radio v-model="params.sorting" :datas="[{key:1,title:'降序'},{key:2,title:'升序'}]"></Radio>
            </FormItem>
            <FormItem class="!pb-5px">
              <Button color="primary" @click="loadList();" :loading="loading">确定</Button>
              <Button @click="this.$refs.paramsDropdown.hide()">取消</Button>
              <Button @click="resetForm">重置</Button>
            </FormItem>
          </Form>
        </template>
      </DropdownCustom>
    </div>
    <div class="h-panel-body voucher-list">
      <table class="header">
        <tr>
          <td style="width: 16%">附件名称</td>
          <td style="width: 16%">凭证号</td>
          <td style="width: 16%">日期</td>
          <td style="width: 16%">大小</td>
          <td style="width: 16%">上传人</td>
          <td style="width: 20%">操作</td>
        </tr>
      </table>
      <table v-if="!datas.length">
        <tr>
          <td colspan="5" class="text-center padding">暂无数据</td>
        </tr>
      </table>
      <div style="height: 650px; overflow-y: auto;">
        <table class="details" v-for="data in datas" :key="data.id">
          <tr>
            <td style="width: 16%">{{ data.name }}</td>
            <td style="width: 16%">
              <router-link class="text-hover primary-color" @success="loadList()" width="1100px"
                          v-if="data.id"
                          :to="{name:'VoucherForm',params:{voucherId:data.id}}">
                {{ data.word }}-{{ data.code }}
              </router-link>
            </td>
            <td style="width: 16%">{{ data.voucherDate }}</td>
            <td style="width: 16%">{{ data.size }}</td>
            <td style="width: 16%">{{ data.createMemberName }}</td>
            <td style="width: 20%">
              <a :href="'/api'+data.url+'?name='+data.name" target="_blank">查看附件</a>
            </td>
          </tr>
        </table>
      </div>
      <Pagination v-model="pagination" @change="currentChange" layout="pager" small align="center"/>
    </div>
  </app-content>
</template>

<script>

import {mapActions, mapGetters, mapState} from 'vuex'
import {h} from 'vue'
import {clone, pick} from "xe-utils";
import {layer} from "@layui/layer-vue";
import VoucherImport from "@/views/voucher/VoucherImport";
import manba from "manba";
import voucher from "@/api/voucher";
import {downloadBlob} from "download.js";
import FinishingOffNo from "@/views/voucher/FinishingOffNo.vue";
import {message} from "heyui.ext";


export default {
  name: "BillList",
  components: {},
  data() {
    return {
      datas: [],
      accountDate: null,
      pagination: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      params: {
        voucherDate: {start: null, end: null},
        sorting:1,
        audit: 0
      },
      loading: false,
    };
  },
  watch: {
  },
  computed: {
    ...mapState(['User', 'currentAccountSets']),
    ...mapGetters(['checkoutSelect', 'localCurrency']),
    date() {
      return manba(this.accountDate);
    }
  },
  methods: {
    dateCheck(){
      // 定义开始时间和结束时间
      let startDate = new Date(this.params.voucherDate.start);
      let endDate = new Date(this.params.voucherDate.end);
      if(startDate > endDate){
        this.$Message({
          type:'warn',
          text: `开始时间必须早于或等于结束时间！`
        });
      }
    },
    ...mapActions(['init']),
    currentChange() {
      this.loadList();
    },
    trigger(key) {
      this[key].call(this);
    },
    processedData(data){
      let processedData = [];
      data.forEach(item => {
        if (item.billList && item.billList.length > 0) {
          item.billList.forEach(billItem => {
            // 复制原始对象的属性
            const newItem = {...item};
            // 添加 billList 的属性
            newItem.name = billItem.name;
            newItem.size  = billItem.size;
            newItem.url = billItem.url;
            // 删除 billList 属性，因为我们已经展开了数据
            delete newItem.billList;
            // 将处理后的项添加到新数组
            processedData.push(newItem);
          });
        } else {
          // 如果没有 billList，直接将原始对象添加到新数组
          // processedData.push(item);无需处理
        }
      });
      console.log(processedData)
      return processedData;
    },
    loadList() {
      this.datas = [];
      const loadId = layer.load(2);
      voucher.billList(this.pagination, this.params).then(({data}) => {
        this.datas = this.processedData(data.results) || [];
        this.pagination = {
          page: data.page,
          size: data.size,
          total: data.total
        }
        this.$refs.paramsDropdown.hide()
      }).finally(() => layer.close(loadId))
    },
  },
  created() {
    this.params.voucherDate.start = manba(this.currentAccountSets.currentAccountDate).format("YYYY-M");
    this.params.voucherDate.end = this.params.voucherDate.start;
    this.cloneParams = clone(this.params, true);
    this.loadList();
  }
};
</script>
<style scoped>
/* jxd css样式调整 */
.h-dropdowncustom{
  margin-top: -2px;
}
</style>